import React, { FC } from "react";
import { Box } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { media } from "@utils/media";
import { BackgroundProps } from ".";

export const SwirlBackdrop: FC<BackgroundProps> = ({
  color = "blue",
  height = "100%",
  left = "none",
  right = "none",
  sx = undefined,
}) => {
  return (
    <Box
      zIndex={-1}
      padding={0}
      pos="absolute"
      left={left}
      right={right}
      width="auto"
      height={height}
      top="none"
      bottom="0"
      sx={{
        display: "block",
        [media.desktop]: {
          display: "none",
        },
        ...(sx ?? {}),
      }}
      overflow="hidden"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        height="100%"
        width="100%"
        viewBox="0 0 710 718"
        preserveAspectRatio="none"
      >
        <motion.path
          d="M17.639 716.176L0.0800247 732.537L32.802 767.655L50.361 751.294L17.639 716.176ZM530.32 121.065L506.709 116.764L530.32 121.065ZM491.506 861L469.103 852.392L500.015 883.441L491.506 861ZM687.509 812.352L709.95 803.844L692.932 758.962L670.491 767.47L687.509 812.352ZM500.015 883.441L687.509 812.352L670.491 767.47L482.998 838.559L500.015 883.441ZM50.361 751.294C77.6516 725.865 198.939 591.928 314.473 455.221C372.449 386.62 429.476 316.734 473.031 258.738C494.785 229.77 513.421 203.45 527.188 181.56C534.067 170.622 539.921 160.491 544.381 151.486C548.665 142.835 552.398 133.786 553.932 125.367L506.709 116.764C506.388 118.525 505.028 122.791 501.367 130.182C497.882 137.219 492.939 145.856 486.556 156.006C473.798 176.291 456.049 201.419 434.65 229.913C391.898 286.839 335.545 355.924 277.812 424.238C161.926 561.362 42.4722 693.037 17.639 716.176L50.361 751.294ZM72.3141 318.648C72.3141 339.712 80.6904 357.157 94.571 370.583C107.755 383.335 125.292 391.94 143.754 398.164C180.493 410.551 229.049 416.069 277.335 420.309C326.892 424.66 376.842 427.711 420.734 434.472C465.627 441.388 497.799 451.429 514.732 465.894L545.908 429.397C517.664 405.271 472.996 393.957 428.042 387.032C382.087 379.953 329.183 376.677 281.533 372.493C232.611 368.197 189.608 362.969 159.089 352.68C143.921 347.566 133.905 341.849 127.943 336.082C122.677 330.989 120.314 325.716 120.314 318.648H72.3141ZM514.732 465.894C528.929 478.021 537.798 504.017 538.377 545.131C538.935 584.767 531.708 631.922 521.377 678.018C511.1 723.875 498.018 767.531 487.465 799.809C482.198 815.921 477.582 829.134 474.293 838.292C472.649 842.87 471.337 846.431 470.444 848.83C469.997 850.029 469.655 850.938 469.428 851.538C469.315 851.837 469.23 852.06 469.175 852.203C469.148 852.275 469.128 852.327 469.116 852.358C469.11 852.374 469.106 852.385 469.104 852.39C469.103 852.393 469.103 852.393 469.102 852.395C469.102 852.394 469.103 852.392 491.506 861C513.909 869.608 513.911 869.603 513.914 869.597C513.915 869.594 513.918 869.586 513.921 869.579C513.926 869.564 513.934 869.544 513.943 869.519C513.963 869.469 513.989 869.399 514.024 869.309C514.093 869.128 514.192 868.868 514.32 868.529C514.576 867.852 514.948 866.864 515.426 865.582C516.38 863.019 517.756 859.282 519.467 854.517C522.889 844.989 527.659 831.335 533.089 814.725C543.932 781.559 557.495 736.349 568.216 688.515C578.883 640.92 587.007 589.56 586.372 544.456C585.758 500.83 576.889 455.861 545.908 429.397L514.732 465.894ZM553.932 125.367C559.669 93.8718 557.085 66.1024 544.112 44.0514C530.883 21.5654 509.201 8.98244 485.089 3.5125C438.67 -7.01777 377.237 7.10088 318.901 33.0974C259.564 59.5404 198.787 100.319 152.493 149.001C106.561 197.303 72.3141 256.201 72.3141 318.648H120.314C120.314 273.678 145.436 226.078 187.277 182.078C228.756 138.458 284.158 101.131 338.44 76.941C393.723 52.3047 443.35 43.2636 474.47 50.3231C489.126 53.6481 497.832 60.0473 502.741 68.3907C507.905 77.1689 511.207 92.0757 506.709 116.764L553.932 125.367Z"
          fill={color}
          stroke={color}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{
            duration: 1,
            yoyo: Infinity,
            ease: "easeInOut",
          }}
        />
      </svg>
    </Box>
  );
};
